





































































































































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { UpdateShopAuditStatus,ShopAuditPass,ShopAuditRefuse,RegistSucccess, QueryShopById, QueryBankCodeList, QueryMccList,LlpayOpenMerchant,QueryShopRegistMerchantListById } from '@/api'
import { ElForm } from 'element-ui/types/form'
import { VImageUpload } from '@/components/upload'
import pcaData from '@/assets/pca.json'
import Rules from '@/utils/rules'
import constant from '@/utils/constant'
import LLpayMechantActity from './components/LLpayMechantActity.vue'
import MerchantOpenCard from './components/MerchantOpenCard.vue'


@Component({
  components: {
    VImageUpload,
    LLpayMechantActity,
    MerchantOpenCard
  },
})
export default class EditShopDialog extends Vue {
  @Prop({ type: Boolean, default: false }) private appendToBody!: boolean

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    const f1 = this.$refs.auditForm as ElForm
    if(f1){
      f1.resetFields()
    }
    this.data = {
      province: undefined,
      city: undefined,
      district: undefined,
      bankCard: { bankType: 1,province:undefined,city:undefined },
      businessLicenseValidityType: "0",
      certValidityType: "0",
      legalLicenceValidityType: "0",
    }
    this.openMerchantList = []
    this.show = false
  }
  // 审核意见
  private form = {
    auditRejectMsg: "",
  }
  private data: any = {
    province: undefined,
    city: undefined,
    district: undefined,
    bankCard: { bankType: 1,province:undefined,city:undefined },
    businessLicenseValidityType: "0",
    certValidityType: "0",
    legalLicenceValidityType: "0",
  }
  private show = false
  private buttonLoading = false
  private pca = pcaData
  // 银行列表
  private bankList: any[] = []
  // 行业
  private mccList: any[] = []
  private ValidityType = constant.ValidityType

  private openMerchantList:any[] =[]

  // 加载商户
  private loadMerchant(){
    QueryShopRegistMerchantListById({id:this.data.id}).then((res:any)=>{
      const d = res
      if(d.filter((e:any)=>e.payChannel == 'huifu').length <= 0){
        d.push({
          payChannel: "huifu",
          payChannelName: "汇付支付",
          applicationStatus: "WAIT",
          agreementSignurl: undefined,
        })
      }
      if(d.filter((e:any)=>e.payChannel == 'llpay').length <= 0){
         d.push({
          payChannel: "llpay",
          payChannelName: "连连支付",
          applicationStatus: "WAIT",
          agreementSignurl: undefined,
        })
      }


      this.openMerchantList = d
    })
  }

  // 获取省数据
  private get provinceList() {
    return this.pca
  }
  // 获取市数据
  private get cityList() {
    if (!this.data.province) {
      return []
    }
    const t = this.pca.filter((e: any) => e.name == this.data.province)
    if (t.length <= 0) {
      return []
    }
    return t[0].children
  }
  private get bankCityList() {
    if (!this.data.bankCard.province) {
      return []
    }
    const t = this.pca.filter((e: any) => e.name == this.data.bankCard.province)
    if (t.length <= 0) {
      return []
    }
    return t[0].children
  }
  // 获取区数据
  private get districtList() {
    if (!this.data.province || !this.data.city) {
      return []
    }
    const t = this.pca.filter((e: any) => e.name == this.data.province)
    if (t.length <= 0) {
      return []
    }
    const t2 = t[0].children.filter((e: any) => e.name == this.data.city)
    if (t2.length == 0) {
      return []
    }
    return t2[0].children
  }

  private provinceChange() {
    console.log("dsadsa")
    this.data.city = undefined;
    this.data.district = undefined;
  }

  private mccCodeChange(){
    const res = this.mccList.filter(e => e.code == this.data.mccCode)
    if (res.length > 0) {
      this.data.mccName = res[0].oneClassifyName+"/"+res[0].twoClassifyName+"/"+res[0].mccName
    } else {
      this.data.mccName = ""
    }
  }

  private bankChange() {
    const res = this.bankList.filter(e => e.bankCode == this.data.bankCard.bankCode)
    if (res.length > 0) {
      this.data.bankCard.bankName = res[0].bankName
    } else {
      this.data.bankCard.bankName = ""
    }
  }

  private llpayOpenActi(){
    const d = this.$refs.LLpayMechantActity as any
    d.open(this.data)
  }

  public created() {
    // 加载银行卡列表
    QueryBankCodeList({}).then(res => {
      this.bankList = res.list
    })
    QueryMccList({}).then(res=>{
      this.mccList = res.list
    })
  }

  public async open(data: any) {
    this.show = true
    this.loadShopById(data.id)

  }

  private async loadShopById(shopId: any) {
    const data = await QueryShopById({ id: shopId })
    if(!data.bankCard.city){
      data.bankCard.city = undefined
    }
    this.data = { ...this.data, ...data }

    // 加载商户
    this.loadMerchant()

    if (this.data.logo) {
      this.data.logoList = this.data.logo.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      this.data.logoList = []
    }
    if (this.data.businessLicense) {
      this.data.businessLicenseList = this.data.businessLicense.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      this.data.businessLicenseList = []
    }
    if (this.data.openAccountLicenceUrl) {
      this.data.openAccountLicenceUrlList = this.data.openAccountLicenceUrl.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      this.data.openAccountLicenceUrlList = []
    }
    if (this.data.legalLicenceFrontUrl) {
      this.data.legalLicenceFrontUrlList = this.data.legalLicenceFrontUrl.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      this.data.legalLicenceFrontUrlList = []
    }
    if (this.data.legalLicenceBackUrl) {
      this.data.legalLicenceBackUrlList = this.data.legalLicenceBackUrl.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      this.data.legalLicenceBackUrlList = []
    }

    if (this.data.storeHeaderPic) {
      this.data.storeHeaderPicList = this.data.storeHeaderPic.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      this.data.storeHeaderPicList = []
    }

    if (this.data.storeIndoorPic) {
      this.data.storeIndoorPicList = this.data.storeIndoorPic.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      this.data.storeIndoorPicList = []
    }

    if (this.data.storeCashierDeskPic) {
      this.data.storeCashierDeskPicList = this.data.storeCashierDeskPic.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      this.data.storeCashierDeskPicList = []
    }

    if (this.data.bankCard.settleCardFrontPic) {
      this.data.bankCard.settleCardFrontPicList = this.data.bankCard.settleCardFrontPic.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      this.data.bankCard.settleCardFrontPicList = []
    }

    if (this.data.bankCard.settleCertBackPic) {
      this.data.bankCard.settleCertBackPicList = this.data.bankCard.settleCertBackPic.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      this.data.bankCard.settleCertBackPicList = []
    }

    if (this.data.bankCard.settleCertFrontPic) {
      this.data.bankCard.settleCertFrontPicList = this.data.bankCard.settleCertFrontPic.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      this.data.bankCard.settleCertFrontPicList = []
    }


  }

  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    // 店铺信息
    name: [this.requiredRule],
    mccCode: [this.requiredRule],
    address: [this.requiredRule],
    shopDesc: [this.requiredRule],
    logo: [this.requiredRule],
    storeHeaderPic: [this.requiredRule],
    storeIndoorPic: [this.requiredRule],
    storeCashierDeskPic: [this.requiredRule],

    // 企业信息
    shopType: [this.requiredRule],
    companyName: [this.requiredRule],
    creditCode: [this.requiredRule],
    businessLicense: [this.requiredRule],
    businessLicenseValidityType: [this.requiredRule],
    businessLicenseBeginDate: [this.requiredRule],
    businessLicenseEndDate: [this.requiredRule],
    businessLicenseFoundDate: [this.requiredRule],
    regCapital: [this.requiredRule],
    openAccountLicenceUrl: [this.requiredRule],
    openLicenceNo: [this.requiredRule],

    // 银行卡信息
    'bankCard.bankType': [this.requiredRule],
    'bankCard.bankCode': [this.requiredRule],
    'bankCard.branchCode': [this.requiredRule],
    'bankCard.accountName': [this.requiredRule],
    'bankCard.accountNo': [this.requiredRule],
    'bankCard.settleCardFrontPic': [this.requiredRule],

    // 对私银行卡额外字段
    'bankCard.bindMobilePhone': [this.requiredRule],
    'bankCard.certNo': [this.requiredRule],
    'bankCard.certValidityType': [this.requiredRule],
    'bankCard.certBeginDate': [this.requiredRule],
    'bankCard.certEndDate': [this.requiredRule],
    'bankCard.settleCertBackPic': [this.requiredRule],
    'bankCard.settleCertFrontPic': [this.requiredRule],

    // 法人信息
    legalName: [this.requiredRule],
    legalPhone: [this.requiredRule],
    legalLicenceNo: [this.requiredRule],
    legalLicenceFrontUrl: [this.requiredRule],
    legalLicenceBackUrl: [this.requiredRule],
    legalLicenceValidityType: [this.requiredRule],
    legalLicenceBeginDate: [this.requiredRule],
    legalLicenceEndDate: [this.requiredRule],
    legalLicenceAddress: [this.requiredRule],

    // 管理员信息
    contactsName: [this.requiredRule],
    contactsLicenceNo: [this.requiredRule],
    contactsEmail: [this.requiredRule, Rules.isEmail],
    contactsPhone: [this.requiredRule, Rules.isMobile]
  }

  public registSucccess(){
    // 入网完成
    this.$confirm(`是否已经完成了当前店铺的所有开户操作?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then((res: any)=>{
      // 变更
      console.log(res)
      RegistSucccess({id:this.data.id}).then(res=>{
        if(res){
          this.$message.success("入网完成")
          this.close()
        }
      })
    })
  }

  /**
   * 连连支付开户
   */
  public openLlpay(){
    this.$confirm('是否确认提交给连连支付？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      LlpayOpenMerchant({id:this.data.id}).then(res=>{
        console.log(res)
      })
    })
  }

  public shopAuditPassFn(){
    // 审核通过
    this.buttonLoading = true
    this.$confirm('是否已经完成了当前店铺的所有开户操作？', '提示', {
       confirmButtonText: '确认 完成',
       cancelButtonText: '取消',
       type: 'warning'
     }).then(() => {
       const param = {
         id: this.data.id,
         auditRejectMsg: this.form.auditRejectMsg
       }
       ShopAuditPass(param).then(res=>{
         if(res){
            this.close()
           this.$message.success("操作成功")
         }
         this.buttonLoading = false
       }).catch(err=>{
        this.buttonLoading = false
      })
      }).catch(err=>{
        this.buttonLoading = false
      })
  }

  public shopAuditRefuseFn(){
    if(!this.form.auditRejectMsg){
      this.$message.error("审核拒绝必需要填写审核意见！")
      return
    }
    // 审核拒绝
    this.buttonLoading = true
    this.$confirm('是否将当前店铺的审核拒绝？', '提示', {
       confirmButtonText: '确认拒绝',
       cancelButtonText: '取消',
       type: 'warning'
     }).then((r) => {
       const param = {
         id: this.data.id,
         auditRejectMsg: this.form.auditRejectMsg
       }
       ShopAuditRefuse(param).then(res=>{
         if(res){
            this.close()
           this.$message.success("操作成功")
         }
         this.buttonLoading = false
       }).catch(err=>{
        this.buttonLoading = false
      })
      }).catch(err=>{
        this.buttonLoading = false
      })
  }

}
